import React, { useRef, useEffect, useState } from 'react';
import { Link } from '../../atoms/link/Link';
import { Heading } from '../../typography/heading/Heading';
import { Text } from '../../typography/text/Text';
import Title from '../../typography/title';
import styles from './InstaBlock.module.scss';
import MediaImage from '@frontastic/catwalk/src/js/mediaImage';
import { headerProps } from './TextProps';
import './InstaBlock.scss';
import { useYotpo } from '../../../utils/useYotpo';

const InstaBlock = ({ label, title, titleUrl, image }) => {
  const { getInstaBlock } = useYotpo();
  const idInstaBlock = getInstaBlock();
  const elementRef = useRef(null);
  const [updateWidget, setUpdateWidget] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (window.yotpo && elementRef?.current?.children.length === 0 && window.yotpo.refreshWidgets) {
        window.yotpo.refreshWidgets();
      }
    }, 500);
  }, [globalThis.yotpo]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            window.yotpo &&
            window.yotpo.refreshWidgets &&
            elementRef?.current?.children?.length &&
            !updateWidget
          ) {
            window.yotpo.refreshWidgets();
            // Stop observing once the block is visible
            observerInstance.unobserve(entry.target);
            setUpdateWidget(true);
          }
        });
      },
      {
        root: null,
        rootMargin: '300px',
        threshold: 0,
      },
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  const instaTitle =
    label || title ? (
      <Title className={styles.instaTitle}>
        {label && (
          <Text
            className={styles.label}
            as="span"
            weight="normal"
            textTransform="uppercase"
          >
            {label}
          </Text>
        )}

        {title && !!titleUrl ? (
          <Link ariaLabel={title} link={{ reference: titleUrl }}>
            <Heading className={styles.header} {...headerProps}>
              {image && <MediaImage media={image} className={styles.image} />}
              {title}
            </Heading>
          </Link>
        ) : title ? (
          <Heading className={styles.header} {...headerProps}>
            {title}
          </Heading>
        ) : null}
      </Title>
    ) : null;

  return (
    <div className={styles.instaSection}>
      {instaTitle}
      <div
        ref={elementRef}
        className="yotpo yotpo-pictures-widget"
        data-gallery-id={idInstaBlock}
      />
    </div>
  );
};

export default InstaBlock;
